import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {ApplicationConfigService} from '@services/application-config.service';

@Injectable()
export class ErrorLoggerService {
    url = '/api/frontend-logger';

    constructor(
        private http: HttpClient,
        private appConfig: ApplicationConfigService,
    ) {}

    log(error: HttpErrorResponse|any, additionalInfo: any = '') {
        let errorData;

        if (error instanceof HttpErrorResponse) {
            errorData = {
                type: 'HttpErrorResponse',
                message: error.message,
                error: error.error,
                statusCode: error.status,
            };
        } else if (error) {
            errorData = {
                type: 'Runtime exception',
                message: error.message,
                stack: error.stack,
            };
        } else {
            errorData = {
                type: 'Custom exception'
            };
        }

        /**
         * Дополнительные данные, чтобы идентифицировать, где мы поймали ошибку
         */
        errorData.additionalInfo = additionalInfo;


        const errorLoggingInfo: ErrorLoggingInfo = {
            user_agent: navigator.userAgent,
            platform: navigator.platform,
            location: {
                href: location.href,
                origin: location.origin,
            },
            error: errorData,
            app_version: this.appConfig.appVersion,
        };

        /**
         * Отправляем ошибку не реагируя на ответ от сервера
         */
        this.http.post(this.url, errorLoggingInfo).toPromise().then(() => {}, () => {});
    }
}

interface ErrorLoggingInfo {
    user_agent: string;
    platform: string;
    location: {
        href: string;
        origin: string;
    };
    app_version: string;
    error: any;
}
